import apiClient from './api-client'

function list() {
  return apiClient.get('roles')
}

const Roles = {
  list,
}

export default Roles
